import { Injectable } from '@angular/core';

@Injectable()
export class ConfigService {
  editorConfig = {
    editable: true,
    spellcheck: false,
    height: '20rem',
    minHeight: '5rem',
    placeholder: '',
    translate: 'no',
    imageEndPoint: 'http://localhost:8082/api/images/uploadnoticia'
  };
}


// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/noticias/components/add-noticia/config.service.ts